import {
  Col,
  Divider,
  Form,
  Row,
  Upload,
  message,
  Checkbox,
  Radio,
  Space,
  Modal,
  ConfigProvider,
  Table,
  Card,
  Alert,
  Image,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import image from "../../resource/image";
import Text from "../../components/Text/Text";
import ImgCrop from "../../components/ImgCrop/ImgCrop";
import styled from "styled-components";
import { color } from "../../resource";
import { ImageWithDeleteButton, UploadIcon } from "../../components/Image/Image";
import DatePicker, { TimePicker } from "../../components/DatePicker/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useForm } from "antd/es/form/Form";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { getBase64 } from "../../utility/uploadHelper";
import { RcFile } from "antd/lib/upload";
import {
  checkShopHighlight,
  createHighlight,
  getHighlightById,
  getShopHighlightById,
  updateHighlight,
} from "../../datasource/News";
import { useEffectOnce } from "react-use";
import { CustomFormItem } from "../AchievementPage/StyleCSS";
import StepAntd from "../../components/StepAntd/StepAntd";
import { DeleteOutlined, ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Select from "../../components/Select/Select";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import { ModalSelectStore } from "../Shared/ModalSelectStore";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { useMessageContext } from "../../context/MessageProvider";
import { dateFormatter } from "../../utility/Formatter";

const UploadVeritical = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 160px;
    width: 120px;
  }
`;

const UploadArea = styled.div`
  background: ${color.background1};
  border: 1px dashed;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
};

const previewSize = 360; //270;

export const CreateHighLightNewsPage: React.FC = () => {
  const { messageApi } = useMessageContext();
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isEdit = pathSplit[2] === "edithighlight";
  const id = pathSplit[3];
  const [currentStep, setCurrentStep] = useState(0);
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;
  const [form] = useForm();
  const [messageError, setMessageError] = useState<any>({ step: undefined, message: "" });

  const [uploading, setUploading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const watchType = form.getFieldValue("type");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    const { responseData } = await getHighlightById(id);
    const { responseData: shopList } = await getShopHighlightById({
      highlightNewsId: id,
    }).then((res) => res);

    form.setFieldsValue({
      ...responseData,
      startDate: dayjs(responseData?.startDate),
      endDate: dayjs(responseData?.endDate),
      startTime: dayjs(responseData?.startDate),
      endTime: dayjs(responseData?.endDate),
      status: responseData.status,
      fileImage: responseData.newsImage,
      fileUrl: responseData.newsImage,
      shops: shopList?.data?.map((shop) => ({ ...shop, checked: false })) || [],
      searchShop: shopList?.data?.map((shop) => ({ ...shop, checked: false })) || [],
      isDup: undefined,
      type: responseData.type,
    });
  };

  useEffect(() => {
    setLoading(true);
    if (isEdit) {
      fetchData();
    } else {
      form.setFieldsValue({
        highlightNewsId: undefined,
        topic: undefined,
        startDate: undefined,
        startTime: dayjs("00:00", "HH:mm"),
        endDate: undefined,
        endTime: dayjs("23:59", "HH:mm"),
        url: undefined,
        isShowOnSaleApp: true,
        isShowOnShopApp: true,
        status: "PUBLISHED",
        fileImage: undefined,
        type: "NEWS",
        fileUrl: undefined,
        shops: [],
        searchShop: [],
        isDup: {},
      });
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, [isEdit, watchType]);

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <StepOne form={form} />;
      case 1:
        return (
          <StepTwo
            form={form}
            company={company}
            messageError={messageError}
            setMessageError={setMessageError}
          />
        );
      case 2:
        return <StepThree form={form} />;
      default:
        return null;
    }
  };

  const onNext = async () => {
    if (currentStep === 0) {
      try {
        await form.validateFields();
        const dataForm = form.getFieldsValue(true);
        if (dataForm.shops && dataForm.shops.length > 0) {
          const payload = {
            highlightNewsId: dataForm.highlightNewsId || null,
            startDate: dayjs(
              `${dayjs(dataForm.startDate).format("YYYY-MM-DD")} ${dayjs(dataForm.startTime).format("HH:mm")}`,
            ).toISOString(),
            endDate: dayjs(
              `${dayjs(dataForm.endDate).format("YYYY-MM-DD")} ${dayjs(dataForm.endTime).format("HH:mm")}`,
            ).toISOString(),
            customerCompanyIds: (dataForm.shops || []).map((shop: any) => {
              return { customerCompanyId: Number(shop.customerCompanyId) };
            }),
          };
          const checkDup = await checkShopHighlight(payload).then((res) => {
            return res;
          });
          const mapNewData = (dataForm.shops || []).map((shop: any) => {
            const isDup = checkDup?.some(
              (dupShop: any) => dupShop.customerCompanyId === shop.customerCompanyId,
            );
            if (isDup) {
              return {
                ...shop,
                isChecked: false,
                isDup: checkDup.find(
                  (dupShop: any) => dupShop.customerCompanyId === shop.customerCompanyId,
                ).highlightNews,
              };
            }
            return {
              ...shop,
              isChecked: false,
              isDup: undefined,
            };
          });

          form.setFieldsValue({
            ...dataForm,
            shops: mapNewData,
            searchShop: mapNewData,
          });
        }
        setCurrentStep((prev) => prev + 1);
      } catch (error) {
        console.log("Validation failed:", error);
      }
    } else if (currentStep === 1) {
      try {
        await form.validateFields();
        const dataForm = form.getFieldsValue(true);
        if (!dataForm.shops || dataForm.shops.length === 0) {
          setMessageError({ step: 1, message: "กรุณาเพิ่มร้านค้า" });
          return;
        }
        setCurrentStep((prev) => prev + 1);
      } catch (error) {
        console.log("Validation failed:", error);
      }
    } else {
      try {
        await form.validateFields();
        setConfirmModal(true);
      } catch (error) {
        console.log("Validation failed:", error);
      }
    }
  };

  const onSave = async () => {
    const dataForm = form.getFieldsValue(true);
    const mapShopData =
      dataForm.shops
        ?.filter((shop: any) => shop.isDup === undefined)
        .map((shop: any) => ({
          newsShopId: shop.newsShopId,
          customerCompanyId: shop.customerCompanyId,
          customerNo: shop.customerNo,
          customerName: shop.customerName,
          zone: shop.zone,
          customerGroupName: shop.customerGroupName,
        })) || [];

    const data = new FormData();
    data.append("company", company);
    data.append("topic", dataForm.topic);
    data.append("isShowOnSaleApp", dataForm.isShowOnSaleApp);
    data.append("isShowOnShopApp", dataForm.isShowOnShopApp);
    data.append("status", dataForm.status);
    dataForm.url && data.append("url", dataForm.url);
    !isEdit && data.append("createdBy", firstname + " " + lastname);
    data.append("updatedBy", firstname + " " + lastname);
    data.append("newsShops", JSON.stringify(JSON.stringify(mapShopData)));

    if (dataForm.startDate && dataForm.startTime)
      data.append(
        "startDate",
        dayjs(
          `${dataForm.startDate?.format("YYYY-MM-DD")} ${dataForm.startTime?.format("HH:mm")}:00.000`,
        ).toISOString(),
      );

    if (dataForm.endDate && dataForm.endTime)
      data.append(
        "endDate",
        dayjs(
          `${dataForm.endDate?.format("YYYY-MM-DD")} ${dataForm.endTime?.format("HH:mm")}:00.000`,
        ).toISOString(),
      );
    form.getFieldValue("fileImage") && data.append("image", form.getFieldValue("fileImage"));

    try {
      setUploading(true);
      if (isEdit) {
        data.append("highlightNewsId", id);
        await updateHighlight(data).then((res) => {
          if (res.success) {
            messageApi.open({
              type: "success",
              content: "แก้ไขสำเร็จ",
            });
            navigate(`/news/highlight`);
          }
        });
      } else {
        await createHighlight(data).then((res) => {
          if (res.success) {
            messageApi.open({
              type: "success",
              content: "บันทึกสำเร็จ",
            });
            navigate(`/news/highlight`);
          }
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setUploading(false);
      setConfirmModal(false);
    }
  };

  return (
    <CardContainer>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <>
          <PageTitleNested
            title={
              isEdit && form.getFieldValue("type") !== "FLASH_SALE"
                ? "แก้ไขข่าวสารไฮไลท์"
                : form.getFieldValue("type") === "FLASH_SALE"
                  ? "ข้อมูลข่าวสารไฮไลท์"
                  : "เพิ่มข่าวสารไฮไลท์"
            }
            showBack
            onBack={() => navigate(`/news/highlight`)}
            extra={
              <>
                <StepAntd
                  current={currentStep}
                  items={[
                    {
                      title: "รายละเอียดข่าว",
                    },
                    {
                      title: "ร้านค้า",
                    },
                    {
                      title: "ตรวจสอบ",
                    },
                  ]}
                />
              </>
            }
            customBreadCrumb={
              <BreadCrumb
                data={[
                  { text: "ข่าวสารไฮไลท์", path: `/news/highlight` },
                  {
                    text:
                      form.getFieldValue("type") === "FLASH_SALE"
                        ? "ข้อมูลข่าวสารไฮไลท์"
                        : "เพิ่มข่าวสารไฮไลท์",
                    path: window.location.pathname,
                  },
                ]}
              />
            }
          />
          <Divider />
          <div style={{ padding: "10px" }}>{renderStep()}</div>
          <Divider />
          <Row justify='space-between' gutter={12}>
            <Col span={3}>
              {currentStep > 0 && (
                <Button
                  typeButton='primary-light'
                  title='ย้อนกลับ'
                  onClick={() => {
                    setMessageError({ step: undefined, message: "" });
                    setCurrentStep(currentStep - 1);
                  }}
                />
              )}
            </Col>
            <Col span={3}>
              {form.getFieldValue("type") !== "FLASH_SALE" ? (
                <Button
                  typeButton='primary'
                  title={currentStep === 2 ? "บันทึก" : "ถัดไป"}
                  onClick={() => {
                    onNext();
                  }}
                />
              ) : (
                <>
                  {currentStep !== 2 && (
                    <Button
                      typeButton='primary'
                      title={"ถัดไป"}
                      onClick={() => {
                        onNext();
                      }}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </>
      )}

      {confirmModal && (
        <Modal
          open={confirmModal}
          closable={false}
          onOk={onSave}
          onCancel={() => setConfirmModal(false)}
          destroyOnClose
          okText={"ยืนยัน"}
          okButtonProps={{ loading: uploading }}
          cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
          centered
        >
          <Text level={2}>
            {isEdit ? "ต้องการยืนยันการแก้ไขข่าวสาร" : "ต้องการยืนยันการสร้างข่าวสารไฮไลท์"}
          </Text>
          <br />
          <Text level={5} color='Text3'>
            {isEdit
              ? "โปรดตรวจสอบรายละเอียดที่คุณต้องการแก้ไขที่ก่อนเสมอ"
              : "โปรดตรวจสอบรายละเอียดที่คุณต้องการสร้างข่าวสารไฮไลน์ก่อนเสมอ"}
            <br />
            เพราะอาจต่อการแสดงผลข่าวสารในระบบแอปพลิเคชัน
          </Text>
        </Modal>
      )}
    </CardContainer>
  );
};

const StepOne = ({ form }: any) => {
  const watchSaleApp = Form.useWatch("isShowOnSaleApp", form);
  const watchShopApp = Form.useWatch("isShowOnShopApp", form);
  const watchFileImage = Form.useWatch("fileImage", form);
  const watchFileUrl = Form.useWatch("fileUrl", form);

  return (
    <>
      <Form
        form={form}
        layout='vertical'
        initialValues={{
          isShowOnSaleApp: true,
          isShowOnShopApp: true,
          startTime: dayjs("00:00", "HH:mm"),
          endTime: dayjs("23:59", "HH:mm"),
          status: true,
        }}
      >
        <Row justify='space-between' gutter={24}>
          <Col span={15}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Text level={5} fontWeight={700}>
                รายละเอียดข้อมูลข่าวสาร
              </Text>
            </div>
            <br />
            <div style={{ padding: "12px" }}>
              <Row>
                <Col span={5}>
                  <CustomFormItem
                    name='fileUrl'
                    valuePropName='file'
                    rules={[
                      {
                        required: true,
                        message: "*กรุณาเพิ่มรูป",
                      },
                    ]}
                  >
                    <ImgCrop aspect={4 / 5} {...imgCropProps}>
                      <UploadVeritical
                        listType='picture-card'
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isJpgOrPng =
                            file.type === "image/jpeg" || file.type === "image/png";
                          if (!isJpgOrPng) {
                            message.error("You can only upload JPG/PNG file!");
                            return true;
                          }
                          form.setFieldValue("fileImage", file);
                          getBase64(file as RcFile, (url) => {
                            form.setFieldValue("fileUrl", url);
                          });
                          return false;
                        }}
                        customRequest={({ file }) => {
                          console.log("customRequest", file);
                        }}
                        onChange={({ file }: any) => {
                          return "success";
                        }}
                        onRemove={() => {
                          form.setFieldValue("fileImage", undefined);
                        }}
                        showUploadList={false}
                        disabled={
                          !!form.getFieldValue("fileImage") || !!form.getFieldValue("fileUrl")
                        }
                      >
                        {!form.getFieldValue("fileUrl") || !form.getFieldValue("fileImage") ? (
                          <UploadArea
                            style={{
                              width: "120px",
                              height: "160px",
                            }}
                          >
                            {UploadIcon}
                          </UploadArea>
                        ) : (
                          <Form.Item name='fileUrl' noStyle>
                            <ImageWithDeleteButton
                              hideDelete={form.getFieldValue("type") === "FLASH_SALE"}
                              width='120px'
                              height='160px'
                              src={form?.getFieldValue("fileUrl")}
                              handleDelete={() => {
                                form.setFieldValue("fileImage", undefined);
                                form.setFieldValue("fileUrl", undefined);
                              }}
                            />
                          </Form.Item>
                        )}
                      </UploadVeritical>
                    </ImgCrop>
                  </CustomFormItem>
                </Col>
                <Col span={18}>
                  <Text level={6}>รูปภาพประกอบไฮไลท์</Text>
                  <br />
                  <Text level={6} color='Text3'>
                    JPG, GIF or PNG. Size of
                    <br />
                    1200*1500px
                    <br />
                    4:5
                  </Text>
                </Col>
              </Row>
            </div>
            <br />
            <Row>
              <Col span={24}>
                <Form.Item
                  name='topic'
                  label='ชื่อข่าวสาร'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดระบุชื่อข่าวสาร",
                    },
                    {
                      max: 50,
                      message: "*ชื่อข่าวสารต้องมีความยาวไม่เกิน 50 ตัวอักษร",
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุชื่อข่าวสาร'
                    style={{ width: "100%" }}
                    autoComplete='off'
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  name='startDate'
                  label='วันที่เริ่มเผยแพร่'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่เริ่มโปรโมชัน",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", color: color.BK }}
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='startTime'
                  label='เวลาเริ่ม'
                  initialValue={dayjs("00:00", "HH:mm")}
                >
                  <TimePicker
                    allowClear={false}
                    style={{ width: "100%", color: color.BK }}
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='endDate'
                  label='วันที่สิ้นสุดเผยแพร่'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่สิ้นสุดโปรโมชัน",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", color: color.BK }}
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                    disabledDate={(current: Dayjs) => {
                      const startDate = form.getFieldValue("startDate");
                      return current && current.isBefore(dayjs(startDate));
                    }}
                    enablePast
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='endTime'
                  label='เวลาสิ้นสุด'
                  initialValue={dayjs("23:59", "HH:mm")}
                >
                  <TimePicker
                    allowClear={false}
                    style={{ width: "100%", color: color.BK }}
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                    disabledTime={(now) => {
                      const startDate = form.getFieldValue("startDate") as Dayjs;
                      const endDate = form.getFieldValue("endDate") as Dayjs;
                      const startTime = form.getFieldValue("startTime") as Dayjs;
                      const isSameDay = startDate && endDate && startDate?.isSame(endDate, "year");
                      if (!isSameDay) return {};

                      const hour = startTime.hour();
                      const minute = startTime.minute();
                      const hours: number[] = [];
                      const minutes: number[] = [];
                      for (let i = 0; i < hour; i++) {
                        hours.push(i);
                      }
                      for (let i = 0; i <= minute; i++) {
                        minutes.push(i);
                      }
                      return {
                        disabledHours: () => hours,
                        disabledMinutes: (selectedHour: number) =>
                          selectedHour === hour ? minutes : [],
                      };
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name='url' label='URL ภาพข่าวสาร'>
                  <Input
                    autoComplete='off'
                    style={{ color: color.BK }}
                    disabled={form.getFieldValue("type") === "FLASH_SALE"}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Text level={5} fontWeight={700}>
                  <span style={{ color: color.error }}>*</span> แอปพลิเคชัน
                </Text>
                <Form.Item
                  name='isShowOnSaleApp'
                  valuePropName='checked'
                  noStyle
                  initialValue={true}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (!value && !form.getFieldValue("isShowOnShopApp")) {
                          return Promise.reject("กรุณาเลือก");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox disabled={form.getFieldValue("type") === "FLASH_SALE"}>
                    Sale App
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  name='isShowOnShopApp'
                  valuePropName='checked'
                  noStyle
                  initialValue={true}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (!value && !form.getFieldValue("isShowOnSaleApp")) {
                          return Promise.reject("กรุณาเลือก");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox disabled={form.getFieldValue("type") === "FLASH_SALE"}>
                    Shop App
                  </Checkbox>
                </Form.Item>
                {!watchSaleApp && !watchShopApp && (
                  <Text level={6} color='error'>
                    * กรุณาเลือกอย่างน้อย 1 แอปพลิเคชัน
                  </Text>
                )}
              </Col>
            </Row>
            <br />
            {form.getFieldValue("highlightNewsId") && (
              <Row>
                <Col span={24}>
                  <Text level={5} fontWeight={700}>
                    <span style={{ color: color.error }}>*</span> สถานะ
                  </Text>
                  <Form.Item
                    name='status'
                    rules={[
                      {
                        required: true,
                        message: "*โปรดเลือกสถานะ",
                      },
                    ]}
                  >
                    <Radio.Group style={{ width: "100%" }}>
                      <Space direction='vertical' style={{ width: "100%" }}>
                        <Radio
                          value='PUBLISHED'
                          disabled={form.getFieldValue("type") === "FLASH_SALE"}
                        >
                          เปิดใช้งาน
                        </Radio>
                        <Radio
                          value='INACTIVE'
                          disabled={form.getFieldValue("type") === "FLASH_SALE"}
                        >
                          ปิดใช้งาน
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Col>
          <Col span={8}>
            <ReviewHighLightNews imageUrl={form.getFieldValue("fileUrl")} />
          </Col>
        </Row>
      </Form>
    </>
  );
};
const StepTwo = ({ form, company, messageError, setMessageError }: any) => {
  const _watchSelectShops = Form.useWatch("searchShop", form);
  const [modalDeleteShop, setModalDeleteShop] = useState(false);
  const [modalShopDup, setModalShopDup] = useState({ open: false, data: null, cusName: null });
  const [selectShopModal, setSelectShopModal] = useState(false);

  const [zoneList, setZoneList] = useState<any>([]);
  const [cusGroupList, setCusGroupList] = useState<any>([]);

  const [searchZone, setSearchZone] = useState<any>(undefined);
  const [searchGroup, setSearchGroup] = useState<any>(undefined);
  const [searchText, setSearchText] = useState<any>(undefined);

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(company).then((res) => {
      setZoneList(res);
    });
  };
  const fetchCustomerGroup = async () => {
    await getShopGroup({ page: 1, take: 999, company: company, isActive: true }).then((res) => {
      const mapData = res.responseData.data.map((group: any) => ({
        label: group.customerGroupName,
        value: group.customerGroupName,
        key: group.customerGroupName,
      }));
      setCusGroupList(mapData);
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchCustomerGroup();
  });

  const onSearchShop = (zone: any, group: any, text: any) => {
    const mapShop = form.getFieldValue("shops");
    const mapSearchShopList = mapShop.filter((shop: any) => {
      const isMatchZone = zone ? shop.zone === zone : true;
      const isMatchGroup = group ? shop.customerGroupName === group : true;
      const isMatchText = text
        ? shop.customerName.toLowerCase().includes(text.toLowerCase()) ||
          shop.customerNo.toLowerCase().includes(text.toLowerCase())
        : true;
      return isMatchZone && isMatchGroup && isMatchText;
    });
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      searchShop: mapSearchShopList,
    });
  };

  const onDeleteShop = () => {
    const mapShop = form.getFieldValue("shops");
    const mapSearchShopList = mapShop.filter((shop: any) => !shop.checked);
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      shops: mapSearchShopList,
      searchShop: mapSearchShopList,
    });
  };

  const columes = [
    {
      title: (
        <>
          {_watchSelectShops && _watchSelectShops?.length > 0 && (
            <Checkbox
              checked={_watchSelectShops?.every((shop: any) => {
                return shop.checked;
              })}
              onChange={(e) => {
                const checked = e.target.checked;
                const mapShop = form.getFieldValue("shops");
                const mapSearchShopList = mapShop.map((shop: any) => {
                  return { ...shop, checked };
                });
                form.setFieldsValue({
                  ...form.getFieldsValue(true),
                  shops: mapSearchShopList,
                  searchShop: mapSearchShopList,
                });
                onSearchShop(searchZone, searchGroup, searchText);
              }}
              disabled={form.getFieldValue("type") === "FLASH_SALE"}
            />
          )}
        </>
      ),
      dataIndex: "checked",
      key: "checked",
      width: "3%",
      render: (value: any, record: any) => {
        return (
          <>
            <Checkbox
              checked={value}
              disabled={form.getFieldValue("type") === "FLASH_SALE"}
              onChange={(e) => {
                const checked = e.target.checked;
                const mapShop = form.getFieldValue("shops");
                const mapShopList = mapShop.map((shop: any) =>
                  shop.customerCompanyId === record.customerCompanyId ? { ...shop, checked } : shop,
                );
                form.setFieldsValue({
                  ...form.getFieldsValue(true),
                  shops: mapShopList,
                  searchShop: mapShopList,
                });
                onSearchShop(searchZone, searchGroup, searchText);
              }}
            />
          </>
        );
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3'>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
              {row.isDup !== undefined && (
                <Text color='error' level={6}>
                  ร้านนี้มีไฮไลน์ข่าวสารอื่นแสดงอยู่ (ร้านจะถูกลบออกเมื่อบันทึก){" "}
                  <u
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setModalShopDup({ open: true, data: row.isDup, cusName: row.customerName })
                    }
                  >
                    ดูเพิ่มเติม
                  </u>
                </Text>
              )}
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "กลุ่มร้านค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Form form={form} layout='vertical'>
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            เลือกร้านค้า
          </span>
        </div>
        <Text level={6} color='error' fontWeight={600}>
          {messageError?.step === 1 && messageError?.message}
        </Text>
        <Row justify={"space-between"} gutter={8}>
          {form.getFieldValue("shops")?.length > 0 ? (
            <>
              <Col span={8}>
                <Input
                  value={searchText}
                  placeholder='ค้นหาชื่อร้านค้า'
                  suffix={<SearchOutlined />}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onPressEnter={(e) => {
                    setSearchText(e.currentTarget.value);
                    onSearchShop(searchZone, searchGroup, e.currentTarget.value);
                  }}
                />
              </Col>
              <Col span={3}>
                <Select
                  value={searchZone}
                  data={
                    zoneList?.map((zone) => ({
                      label: zone.zoneName,
                      value: zone.zoneName,
                      key: zone.zoneName,
                    })) || []
                  }
                  placeholder='เลือกเขต'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSearchZone(e);
                    onSearchShop(e, searchGroup, searchText);
                  }}
                />
              </Col>
              <Col span={4}>
                <Select
                  value={searchGroup}
                  data={
                    cusGroupList?.map((group) => ({
                      label: group.label,
                      value: group.value,
                      key: group.key,
                    })) || []
                  }
                  placeholder='กลุ่มร้านค้า'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSearchGroup(e);
                    onSearchShop(searchZone, e, searchText);
                  }}
                />
              </Col>
              <Col span={3}>
                <Button
                  typeButton='primary-light'
                  title='ล้างการค้นหา'
                  onClick={() => {
                    setSearchZone(undefined);
                    setSearchGroup(undefined);
                    setSearchText(undefined);
                    onSearchShop(undefined, undefined, undefined);
                  }}
                />
              </Col>
              <Col span={2} />
              <Col style={{ paddingTop: "10px" }}>
                {form?.getFieldValue("shops")?.some((shop: any) => shop.checked) && (
                  <DeleteOutlined
                    onClick={() => setModalDeleteShop(true)}
                    style={{ fontSize: "20px", color: color.error, cursor: "pointer" }}
                  />
                )}
                {modalDeleteShop && (
                  <Modal
                    open={modalDeleteShop}
                    centered
                    closable={true}
                    maskClosable={false}
                    okText='บันทึก'
                    cancelText='ยกเลิก'
                    title={
                      <Text fontWeight={600} level={2}>
                        ลบร้านค้าที่เลือก
                      </Text>
                    }
                    onOk={() => {
                      onDeleteShop();
                      onSearchShop(searchZone, searchGroup, searchText);
                      setModalDeleteShop(false);
                    }}
                    onCancel={() => setModalDeleteShop(false)}
                    cancelButtonProps={{
                      style: { borderColor: color.primary, color: color.primary },
                    }}
                  >
                    <Text color='Text3'>โปรดยืนยันการลบร้านค้า</Text>
                    <Divider size='small' />
                  </Modal>
                )}
              </Col>
            </>
          ) : (
            <Col span={21} />
          )}
          <Col span={3}>
            {form.getFieldValue("type") !== "FLASH_SALE" && (
              <Button
                typeButton='primary'
                title='เพิ่มร้านค้า'
                onClick={() => setSelectShopModal(true)}
              />
            )}
          </Col>
        </Row>
        <Row justify={"end"} gutter={8} style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <Col>
            <Text>จำนวน {form.getFieldValue("searchShop")?.length || 0} ร้าน</Text>
          </Col>
        </Row>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                headerColor: "#FFFFFF",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Form.Item name='searchShop' noStyle>
            <Table
              columns={columes}
              dataSource={form.getFieldValue("searchShop") || []}
              rowKey='customerCompanyId'
              tableLayout='fixed'
              scroll={{
                y: 600,
              }}
              pagination={false}
            />
          </Form.Item>
        </ConfigProvider>
      </Form>
      {selectShopModal && (
        <ModalSelectStore
          callBackShop={async (data) => {
            const mapShop = data.map((shop: any) => {
              return {
                ...shop,
                isChecked: false,
              };
            });
            const payload = {
              highlightNewsId: form.getFieldValue("highlightNewsId") || null,
              startDate: dayjs(
                `${dayjs(form.getFieldValue("startDate")).format("YYYY-MM-DD")} ${dayjs(form.getFieldValue("startTime")).format("HH:mm")}`,
              ).toISOString(),
              endDate: dayjs(
                `${dayjs(form.getFieldValue("endDate")).format("YYYY-MM-DD")} ${dayjs(form.getFieldValue("endTime")).format("HH:mm")}`,
              ).toISOString(),
              customerCompanyIds: [...(form.getFieldValue("shops") || []), ...mapShop].map(
                (shop: any) => {
                  return { customerCompanyId: shop.customerCompanyId };
                },
              ),
            };
            setMessageError({ step: undefined, message: "" });
            const checkDup = await checkShopHighlight(payload).then((res) => {
              return res;
            });

            const mapNewData = [...(form.getFieldValue("shops") || []), ...mapShop].map(
              (shop: any) => {
                const isDup = checkDup?.some(
                  (dupShop: any) => dupShop.customerCompanyId === shop.customerCompanyId,
                );
                if (isDup) {
                  return {
                    ...shop,
                    isChecked: false,
                    isDup: checkDup.find(
                      (dupShop: any) => dupShop.customerCompanyId === shop.customerCompanyId,
                    ).highlightNews,
                  };
                }
                return {
                  ...shop,
                  isChecked: false,
                  isDup: undefined,
                };
              },
            );

            form.setFieldsValue({
              shops: mapNewData,
              searchShop: mapNewData,
            });
            setSelectShopModal(false);
          }}
          showModalShop={selectShopModal}
          currentSelectShop={form.getFieldValue("shops") || []}
          company={company}
          onClose={() => setSelectShopModal(false)}
        />
      )}
      {modalShopDup.open && (
        <ModalShopDup
          showModal={modalShopDup.open}
          cusName={modalShopDup.cusName}
          data={modalShopDup.data}
          onClose={() => setModalShopDup({ open: false, data: null, cusName: null })}
        />
      )}
    </>
  );
};
const StepThree = ({ form }: any) => {
  const dataForm = form.getFieldsValue(true);
  const [modalShopDup, setModalShopDup] = useState({ open: false, data: null, cusName: null });

  const into = [
    { label: "หัวข้อข่าว", value: dataForm?.topic || "-" },
    {
      label: "วันที่เริ่มต้น และสิ้นสุดในการเผยแพร่",
      value: `${dayjs(dataForm?.startDate).format("DD/MM/YYYY")}, ${dayjs(dataForm?.startTime).format("HH:mm")} - ${dayjs(dataForm?.endDate).format("DD/MM/YYYY")}, ${dayjs(dataForm?.endTime).format("HH:mm")}`,
    },
    {
      label: "URL",
      value: dataForm?.url?.length > 40 ? dataForm?.url.slice(0, 40) + "..." : dataForm?.url || "-",
    },
    {
      label: "แอปพลิเคชันที่เผยแพร่",
      value: [dataForm?.isShowOnSaleApp, dataForm?.isShowOnShopApp]
        .map((item, index) => (item ? (index === 0 ? "Sale App" : "Shop App") : ""))
        .filter((item) => item !== "")
        .join(", "),
    },
  ];

  return (
    <>
      <Row justify='space-between' gutter={12}>
        <Col span={15}>
          <Text level={4} fontWeight={700}>
            ตรวจสอบข้อมูล
          </Text>
          <Row justify='space-between' gutter={[16, 16]}>
            {into.map((item, index) => (
              <Col key={index} span={12}>
                <Card
                  bodyStyle={{
                    padding: 10,
                    backgroundColor: "#F3F6F9",
                    borderRadius: 8,
                    border: "none",
                  }}
                >
                  <Text color='Text3' fontFamily='Sarabun'>
                    {item.label}
                  </Text>
                  <br />
                  <Text fontFamily='Sarabun'>{item.value}</Text>
                </Card>
              </Col>
            ))}
          </Row>
          <br />
          <div style={{ marginBottom: 16 }}>
            <Text fontWeight={700}>
              ร้านค้าที่เห็นข่าว {form.getFieldValue("shops")?.length || 0} ร้าน
            </Text>
          </div>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#F3F6F9",
                  headerColor: "black",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                },
              },
            }}
          >
            <Form.Item name='shops' noStyle>
              <Table
                size='small'
                columns={[
                  {
                    title: "ชื่อร้านค้า",
                    dataIndex: "customerName",
                    key: "customerName",
                    width: "30%",
                    render: (value: any, row: any, index: number) => {
                      return {
                        children: (
                          <FlexCol>
                            <Text>{value}</Text>
                            <Text color='Text3'>
                              {row.customerNo} • เขต {row.zone} • กลุ่ม{" "}
                              {row.customerGroupName || "-"}
                            </Text>
                            {row.isDup !== undefined && (
                              <Text color='error' level={6}>
                                ร้านนี้มีไฮไลน์ข่าวสารอื่นแสดงอยู่ (ร้านจะถูกลบออกเมื่อบันทึก){" "}
                                <u
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setModalShopDup({
                                      open: true,
                                      data: row.isDup,
                                      cusName: row.customerName,
                                    })
                                  }
                                >
                                  ดูเพิ่มเติม
                                </u>
                              </Text>
                            )}
                          </FlexCol>
                        ),
                      };
                    },
                  },
                  {
                    title: "เขต",
                    dataIndex: "zone",
                    key: "zone",
                    width: "10%",
                    render: (value: any, row: any, index: number) => {
                      return {
                        children: (
                          <FlexCol>
                            <Text>{value || "-"}</Text>
                          </FlexCol>
                        ),
                      };
                    },
                  },
                  {
                    title: "กลุ่มร้านค้า",
                    dataIndex: "customerGroupName",
                    key: "customerGroupName",
                    width: "10%",
                    render: (value: any, row: any, index: number) => {
                      return {
                        children: (
                          <FlexCol>
                            <Text>{value || "-"}</Text>
                          </FlexCol>
                        ),
                      };
                    },
                  },
                ]}
                dataSource={form.getFieldValue("shops") || []}
                rowKey='customerCompanyId'
                tableLayout='fixed'
                scroll={{
                  y: 400,
                }}
                pagination={false}
              />
            </Form.Item>
          </ConfigProvider>
        </Col>
        <Col span={8}>
          <Text fontWeight={700}>ภาพตัวอย่างในแอปพลิเคชัน</Text>
          <ReviewHighLightNews imageUrl={form.getFieldValue("fileUrl")} />
        </Col>
      </Row>
      {modalShopDup.open && (
        <ModalShopDup
          showModal={modalShopDup.open}
          cusName={modalShopDup.cusName}
          data={modalShopDup.data}
          onClose={() => setModalShopDup({ open: false, data: null, cusName: null })}
        />
      )}
    </>
  );
};

export const ReviewHighLightNews = ({ imageUrl }: any) => {
  return (
    <>
      <div
        style={{
          position: "absolute",
          margin: "108px 9px 0px",
          width: previewSize,
          height: previewSize * 1.25,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(${imageUrl})`,
          backgroundColor: "#FFFFFF40",
          borderRadius: 4,
        }}
      />
      <div
        style={{
          width: previewSize + 18,
          height: 740,
          backgroundRepeat: "no-repeat",
          backgroundSize: `${previewSize + 18}px 740px`,
          backgroundImage: `url(${image.indexHighLightApp})`,
        }}
      />
    </>
  );
};
const ModalShopDup = ({ showModal, data, onClose, cusName }: any) => {
  const columns = [
    {
      title: "วันที่เผยแพร่",
      dataIndex: "date",
      key: "date",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row>
              <Text level={5}>{dateFormatter(row.startDate, true)}</Text> -{" "}
              <Text level={5}>{dateFormatter(row.endDate, true)}</Text>
            </Row>
          ),
        };
      },
    },
    {
      title: "ชื่อข่าวสาร",
      dataIndex: "topic",
      key: "topic",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow style={{ alignItems: "center", gap: "10px" }}>
              <Image
                src={row.newsImage}
                height={60}
                width={60}
                style={{ borderRadius: "5px", objectFit: "cover" }}
              />
              <Text level={5}>{value || "-"}</Text>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "รูปแบบ",
      dataIndex: "type",
      key: "type",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value === "NEWS" ? "ข่าวสาร" : "Flash Sale"}</Text>,
        };
      },
    },
  ];
  return (
    <Modal
      open={showModal}
      onCancel={onClose}
      footer={null}
      centered
      width={1000}
      title={
        <>
          <Text level={4} fontWeight={700}>
            ไฮไลท์ข่าวสารที่กำลังแสดงให้ร้าน
          </Text>
          <br />
          <Text>{cusName || ""}</Text>
        </>
      }
    >
      <Alert
        icon={<ExclamationCircleOutlined style={{ fontSize: "20px", color: color.warning }} />}
        showIcon
        description={<Text level={6}>ภาพไฮไลท์ข่าวสารแสดงได้สูงสุด 1 ร้านค้า</Text>}
        style={{
          padding: "8px",
          borderRadius: "4px",
          border: "none",
          backgroundColor: "#FFF5F5",
          alignItems: "center",
        }}
      />
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              headerColor: "black",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          scroll={{ x: "max-content" }}
          columns={columns}
          dataSource={(data && [data]) || []}
          pagination={false}
        />
      </ConfigProvider>
    </Modal>
  );
};
